module.exports = __webpack_public_path__ + "static/img/R3.0635b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/R3.png
// module id = B06v
// module chunks = 0